import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MyDEQCoreModule } from '../../core/core.module';
import { SharedModule } from '../../shared/shared.module';
import { ComponentPageModule } from '../components/componet.module';
import { commonRouting } from './common.routes';

import { SearchCriteriaComponent } from './search-criteria/search-criteria.component';
import { SearchResultComponent } from './search-result/search-result.component';
import { SearchCriteriaUSTCRComponent } from './ust-cr/search-criteria-ust-cr/search-criteria-ust-cr.component';
import { SearchResultUSTCRComponent } from './ust-cr/search-result-ust-cr/search-result-ust-cr.component';
import { ApprovedListComponent } from './approved-list/approved-list.component';

@NgModule({

    imports: [
        FormsModule,
        CommonModule,
        ReactiveFormsModule,
        NgbModule,
        RouterModule,
        commonRouting,
        MyDEQCoreModule,
        ComponentPageModule,
        SharedModule,
    ],
    declarations: [      
        SearchCriteriaComponent,
        SearchResultComponent,
        ApprovedListComponent,
        
        SearchResultUSTCRComponent,
        SearchCriteriaUSTCRComponent
    ],
    // exports: [
    //     SearchCriteriaComponent,
    //     SearchResultComponent,
        
    //     SearchResultUSTCRComponent,
    //     SearchCriteriaUSTCRComponent
    // ]
})
export class CommonPageModule{}



